module.exports = __webpack_public_path__ + "static/cypressnorth-3a812f6c7ea292dd2ba286193bb507e7.png";